import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DynamicFavicon = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/site-settings`)
      .then(res => res.json())
      .then(data => setSettings(data))
      .catch(err => console.error('Error fetching site settings:', err));
  }, []);

  useEffect(() => {
    if (!settings) return;

    // Determine favicon URL (use logo_header as fallback)
    const faviconUrl = settings.favicon || settings.logo_header;
    
    if (!faviconUrl) return;

    // Update existing favicon links or create new ones
    const updateFavicon = (rel, href) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    // Set multiple favicon formats for better browser support
    updateFavicon('icon', faviconUrl);
    updateFavicon('shortcut icon', faviconUrl);
    updateFavicon('apple-touch-icon', faviconUrl);

    // Also update the page title if logo_alt is set
    if (settings.logo_alt) {
      document.title = settings.logo_alt;
    }

  }, [settings]);

  return null;
};

export default DynamicFavicon;
